<template>
  <div id="custom-table-list" class="custom-table-container">
    <daily-cover-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :daily-cover="sidebarData"
    />

    <daily-cover-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />

    <vs-table
      ref="table"
      multiple
      :sst="true"
      @sort="handleSort"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      :data="dailyCovers"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          @emitAddNewData="addNewData"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th>Imagem de Capa</vs-th>
        <vs-th>PDF</vs-th>
        <vs-th>Agendado Para</vs-th>
        <vs-th>Ativo</vs-th>
        <vs-th>Criado Em</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="whitespace-no-wrap">
              <a :href="tr.picture_url" target="_blank">
                <img :src="tr.picture_url" alt="" :title="tr.picture_url" width="64" />
              </a>
            </vs-td>

            <vs-td>
              <vs-button 
                target
                :href="{url: tr.url}"
                type="flat"
                size="small"
                icon="picture_as_pdf"
              >
                Visualizar Arquivo
              </vs-button>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.schedule_publish_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-activated font-medium">
                <ActiveItem :active="tr.activated" />
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.created_at) }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import DailyCoverViewSidebar from './DailyCoverViewSidebar'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleDailyCover from '@/store/dailyCover/moduleDailyCover'
  import { defineSortFieldDirection, formatDate } from '@/utils'

  export default {
    name: 'daily-covers-list',
    components: {
      DailyCoverViewSidebar,
      ActiveItem,
      HeaderList
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        }
      }
    },
    computed: {
      dailyCovers() {
        return this.$store.state.dailyCover.dailyCovers
      },
      totalPages() {
        return this.$store.state.dailyCover.totalPages
      }
    },
    watch: {
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    methods: {
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      editData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      deleteData(dailyCoverId) {
        this.$store.dispatch("dailyCover/delete", dailyCoverId)
          .catch(err => { console.error(err) })
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            name: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleDailyCover.isRegistered) {
          this.$store.dispatch("dailyCover/fetch", {
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }
      },
      formatStringDate(date) {
        if (!date) {
          return ''
        }
        
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleDailyCover.isRegistered) {
        this.$store.registerModule('dailyCover', moduleDailyCover)
        moduleDailyCover.isRegistered = true
      }
      
      this.fetchData();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>